// extracted by css-extract-rspack-plugin
export default {"root":"G3ueav","align-items-center":"MFMO8f","alignItemsCenter":"MFMO8f","input":"OD9_Ja"};